<template>
	<div class="page">
		<router-view/>
		<!--<img class="page__background" src="@/assets/img/page-backgrounds/studying.svg">-->
	</div>
</template>

<script>

export default {
	data () {
		return {
		}
	}
}
</script>

<style lang="scss" scoped>
.page__background {
	width: 500px;
	opacity: 0.5;
	position: absolute;
	right: 50px;
	bottom: 50px;
}
</style>
